import { type } from "arktype";

export const syncSettingsSchema = type({
  customEventName: "string",
  excludeEventName: "boolean",
  excludeEventDescription: "boolean",
  excludeEventLocation: "boolean",
  markEventsAsPrivate: "boolean",
});
export type SyncSettings = typeof syncSettingsSchema.infer;
export const syncSettingsPatchSchema = type({
  "customEventName?": "string",
  "excludeEventName?": "boolean",
  "excludeEventDescription?": "boolean",
  "excludeEventLocation?": "boolean",
  "markEventsAsPrivate?": "boolean",
  "+": "reject",
});
export type SyncSettingsPatch = typeof syncSettingsPatchSchema.infer;
